/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type PreemptLockMutationVariables = Types.Exact<{
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  componentId: Types.Scalars["String"]["input"];
  componentType: Types.LockComponentType;
}>;

export type PreemptLockMutation = {
  readonly __typename: "Mutation";
  readonly preemptLock: ReadonlyArray<{
    readonly __typename: "UILock";
    readonly id: c.UILockId;
    readonly componentId: string;
    readonly componentType: Types.LockComponentType;
    readonly expires: c.DateTimeString;
    readonly expired: boolean | null;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly user: {
      readonly __typename: "User";
      readonly id: c.UserId;
      readonly name: string | null;
      readonly email: string;
      readonly imageUrl: string | null;
    };
  }>;
};

export type AcquireLockMutationVariables = Types.Exact<{
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  componentType: Types.LockComponentType;
  componentId: Types.Scalars["String"]["input"];
}>;

export type AcquireLockMutation = {
  readonly __typename: "Mutation";
  readonly acquireLock: ReadonlyArray<{
    readonly __typename: "UILock";
    readonly id: c.UILockId;
    readonly componentId: string;
    readonly componentType: Types.LockComponentType;
    readonly expires: c.DateTimeString;
    readonly expired: boolean | null;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly user: {
      readonly __typename: "User";
      readonly id: c.UserId;
      readonly name: string | null;
      readonly email: string;
      readonly imageUrl: string | null;
    };
  }>;
};

export const PreemptLockDocument = /*#__PURE__*/ gql`
  mutation PreemptLock(
    $hexVersionId: HexVersionId!
    $componentId: String!
    $componentType: LockComponentType!
  ) {
    preemptLock(
      hexVersionId: $hexVersionId
      componentId: $componentId
      componentType: $componentType
    ) {
      id
      componentId
      componentType
      user {
        id
        name
        email
        imageUrl
      }
      expires
      expired
      updatedDate
      deletedDate
    }
  }
`;
export type PreemptLockMutationFn = Apollo.MutationFunction<
  PreemptLockMutation,
  PreemptLockMutationVariables
>;

/**
 * __usePreemptLockMutation__
 *
 * To run a mutation, you first call `usePreemptLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreemptLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preemptLockMutation, { data, loading, error }] = usePreemptLockMutation({
 *   variables: {
 *      hexVersionId: // value for 'hexVersionId'
 *      componentId: // value for 'componentId'
 *      componentType: // value for 'componentType'
 *   },
 * });
 */
export function usePreemptLockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PreemptLockMutation,
    PreemptLockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PreemptLockMutation, PreemptLockMutationVariables>(
    PreemptLockDocument,
    options,
  );
}
export type PreemptLockMutationHookResult = ReturnType<
  typeof usePreemptLockMutation
>;
export type PreemptLockMutationResult =
  Apollo.MutationResult<PreemptLockMutation>;
export type PreemptLockMutationOptions = Apollo.BaseMutationOptions<
  PreemptLockMutation,
  PreemptLockMutationVariables
>;
export const AcquireLockDocument = /*#__PURE__*/ gql`
  mutation AcquireLock(
    $hexVersionId: HexVersionId!
    $componentType: LockComponentType!
    $componentId: String!
  ) {
    acquireLock(
      hexVersionId: $hexVersionId
      componentType: $componentType
      componentId: $componentId
    ) {
      id
      componentId
      componentType
      user {
        id
        name
        email
        imageUrl
      }
      expires
      expired
      updatedDate
      deletedDate
    }
  }
`;
export type AcquireLockMutationFn = Apollo.MutationFunction<
  AcquireLockMutation,
  AcquireLockMutationVariables
>;

/**
 * __useAcquireLockMutation__
 *
 * To run a mutation, you first call `useAcquireLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcquireLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acquireLockMutation, { data, loading, error }] = useAcquireLockMutation({
 *   variables: {
 *      hexVersionId: // value for 'hexVersionId'
 *      componentType: // value for 'componentType'
 *      componentId: // value for 'componentId'
 *   },
 * });
 */
export function useAcquireLockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcquireLockMutation,
    AcquireLockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AcquireLockMutation, AcquireLockMutationVariables>(
    AcquireLockDocument,
    options,
  );
}
export type AcquireLockMutationHookResult = ReturnType<
  typeof useAcquireLockMutation
>;
export type AcquireLockMutationResult =
  Apollo.MutationResult<AcquireLockMutation>;
export type AcquireLockMutationOptions = Apollo.BaseMutationOptions<
  AcquireLockMutation,
  AcquireLockMutationVariables
>;
